var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MAffix',{style:(_vm.noClick ? { pointerEvents: 'none' } : {}),on:{"change":function($event){_vm.affixed = $event}}},[_c('MTab',_vm._g(_vm._b({class:{
      'affixed-tab': _vm.affixed,
      'flex-tab h-100': _vm.$attrs['position'] === 'left',
    },model:{value:(_vm.currentModule),callback:function ($$v) {_vm.currentModule=$$v},expression:"currentModule"}},'MTab',_vm.$attrs,false),_vm.listeners),_vm._l((_vm.modules),function(m){return _c('MTabPane',{key:m.moduleName,attrs:{"tab":m.text}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }